const cartDisableAllButtons = () => {
	const cartContainer = document.querySelector('[id="cartContainer"]');

	if (cartContainer) {
		cartContainer.addEventListener('click', handleClick);
		cartContainer.addEventListener('submit', handleSubmit);
	}
};

function handleClick(e) {
	const cartUpdateButtons = document.querySelectorAll('[data-cart-update-btn]');
	if (Array.prototype.includes.call(cartUpdateButtons, e.target)) {
		setTimeout(disableButtons, 0);
	}
}

function handleSubmit(e) {
	const cartUpdateForms = document.querySelectorAll('[data-cart-update-form]');
	if (Array.prototype.includes.call(cartUpdateForms, e.target)) {
		setTimeout(disableButtons, 0);
	}
}

function disableButtons() {
	const cartUpdateButtons = document.querySelectorAll('[data-cart-update-btn]');
	Array.prototype.forEach.call(cartUpdateButtons, btn => {
		btn.disabled = true;
		btn.classList.add('btn--is-waiting');
	});
}

export default cartDisableAllButtons;
